module.exports = __webpack_public_path__ + "img/27b1f8e18b25745552661363de30b96c.png";